import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "content-header" }, "Settings", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "content-subheader" }, "Configure your settings here", -1)
const _hoisted_3 = { class: "settings-container" }
const _hoisted_4 = { class: "row w-100" }
const _hoisted_5 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-key fs-3x text-primary" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "settings-header" }, "Change Password", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "settings-subheader" }, "Modify current password", -1)
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-user fs-3x text-primary" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", { class: "settings-header" }, "Account Settings", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "settings-subheader" }, "Personal Details", -1)
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-user fs-3x text-primary" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h1", { class: "settings-header" }, "Subscriptions", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "settings-subheader" }, "Subscription Details", -1)
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/settings/change-password'))),
            class: "settings-item d-flex flex-column justify-content-center w-100"
          }, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/profile/overview'))),
            class: "settings-item d-flex flex-column justify-content-center w-100"
          }, _hoisted_14)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/settings/subscriptions'))),
            class: "settings-item d-flex flex-column justify-content-center w-100"
          }, _hoisted_19)
        ])
      ])
    ])
  ]))
}